import { getLocaleInfo } from './info';

export default function numberSymbols(locale) {
    var info = getLocaleInfo(locale);

    return info.numbers.symbols;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@telerik/kendo-intl/dist/es/cldr/number-symbols.js
// module id = 1619
// module chunks = 30